import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

export default function UnsubmittedChart({ data }: any) {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart | null>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    // Destroy existing chart instance to prevent duplicates
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const countByTribe = data.reduce((acc: any[], item: any) => {
      acc[item.OrganizationCode] = (acc[item.OrganizationCode] || 0) + 1;
      return acc;
    }, {});
    const chartData = Object.entries(countByTribe).map(([OrganizationCode, count]) => ({
      OrganizationCode,
      count
    }));
    chartData.sort((a, b) => a.OrganizationCode.localeCompare(b.OrganizationCode));
    console.log(chartData);

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels: chartData.map((row: any) => row["OrganizationCode"]),
        datasets: [
          {
            label: "Unsubmitted Reports",
            data: chartData.map(
              (row: any) => row["count"]
            ),
          },
        ],
      },
      options: {
        aspectRatio: 2,
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          y: {
            
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                const index = context.dataIndex;
                const row = chartData[index];
                const count = row["count"];

                return `Unsubmitted Reports: ${count}`;
              },
            },
          },
        },
      },
    });
  }, [data]);

  return <div className="chart-container" style={{ position: "relative", height: "40vh", width: "100%" }}><canvas id="report-chart" ref={chartRef} /></div>;
}
